import React, {ReactNode} from 'react'
import PPSelect, {OptionProps} from '../../shared/forms/PPSelect'
import {AdminDefaultButton} from '../../../styledComponents/adminPage/Buttons'
import {DeleteLink} from '../../../styledComponents/adminPage/Links'
import {LeftColumnFlexContainer, LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {InnerMiniTable, InnerMiniTableBody, InnerMiniTableCell} from '../../../styledComponents/adminPage/Table'
import equal from 'fast-deep-equal'
import {addEmptyData, NoSelectedValue} from '../../../componentHelper/selectHelper'
import EventEmitterExAdmin from '../../shared/pageBaseComponents/EventEmitterExAdmin'
import PPErrorLabel from '../../shared/forms/PPErrorLabel'
import { TableRow } from '@mui/material';
import {SelectChangeEvent} from '@mui/material/Select'

interface Props {
    masterData: OptionProps[]
    selectedIdList: number[]
    required: boolean
    eventEmitter: EventEmitterExAdmin
    onChange?: (selectedIdList: number[]) => void
}

interface State {
    selectedItemValue: string
}

class EquipmentsSelector extends React.Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)

        this.handleChangeSelect = this.handleChangeSelect.bind(this)
        this.handleClick = this.handleClick.bind(this)

        this.state = {selectedItemValue: NoSelectedValue}
    }

    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>): boolean {
        return !(
            (this.props === nextProps || equal(this.props, nextProps))
            && (this.state === nextState || equal(this.state, nextState))
        )
    }

    handleChangeSelect(event: SelectChangeEvent<unknown>, _: React.ReactNode): void {
        this.setState({selectedItemValue: `${event.target.value}`})
    }

    handleClick(): void {
        if (!this.props.onChange) {
            return
        }

        const {selectedIdList} = this.props
        if (this.state.selectedItemValue !== NoSelectedValue) {
            this.props.onChange([...selectedIdList, Number(this.state.selectedItemValue)])
            this.setState({
                selectedItemValue: NoSelectedValue,
            })
        }
    }

    deleteLinkClick = (value: number) => (_: React.MouseEvent<HTMLElement>) => {
        if (!this.props.onChange) {
            return
        }

        const {selectedIdList} = this.props
        this.props.onChange(selectedIdList.filter(id => (id !== value)))
    }

    renderAddedEquipmentsTable(selectedIdList: number[]): ReactNode {
        if (selectedIdList.length === 0) {
            return null
        }
        const {masterData} = this.props
        return (
            <InnerMiniTable>
                <InnerMiniTableBody>
                    {
                        selectedIdList.map((id, index) => {
                            const optionProps: OptionProps | undefined =
                                masterData
                                    .find(item => item.value === `${id}`)
                            if (optionProps === undefined) {
                                return null
                            }
                            return (
                                <TableRow key={id}>
                                    <InnerMiniTableCell>{index + 1}</InnerMiniTableCell>
                                    <InnerMiniTableCell>
                                        {optionProps.label}
                                        <PPErrorLabel
                                            eventEmitter={this.props.eventEmitter}
                                            eventKeys={[`equipmentIds[${id}]`]}
                                        />
                                    </InnerMiniTableCell>
                                    <InnerMiniTableCell>
                                        <DeleteLink
                                            onClick={this.deleteLinkClick(id)}
                                        >
                                            削除
                                        </DeleteLink>
                                    </InnerMiniTableCell>
                                </TableRow>
                            )
                        })
                    }
                </InnerMiniTableBody>
            </InnerMiniTable>
        )
    }

    render(): ReactNode {
        const {masterData, selectedIdList} = this.props

        const selectableList: OptionProps[] = masterData
            .filter(item => {
                return !selectedIdList.includes(Number(item.value))
            })

        return <>
            <LeftColumnFlexContainer>
                <LeftRowFlexContainer>
                    <PPSelect
                        data={addEmptyData(selectableList, '設備を選択してください')}
                        required={this.props.required}
                        onChange={this.handleChangeSelect}
                    />
                    <AdminDefaultButton
                        size={'small'}
                        disabled={this.state.selectedItemValue === NoSelectedValue}
                        onClick={this.handleClick}
                    >
                        設備追加
                    </AdminDefaultButton>
                </LeftRowFlexContainer>
                {this.renderAddedEquipmentsTable(selectedIdList)}
            </LeftColumnFlexContainer>
        </>
    }
}

export default EquipmentsSelector
